import { UnderwrittenExcess } from '@acorn-portal/shared/src/services/subscriptionAPI';

export const getCompulsoryExcess = (excesses: UnderwrittenExcess[] | undefined): number => {
	if (!excesses || excesses.length === 0) return 0;
	return excesses.reduce((total, excess) => total + (excess.compulsoryAmount ?? 0), 0);
};
